<form class="search-bar" [formGroup]="searchFilter" (ngSubmit)="onFormSubmit()">
  <div class="search-wrapper">
    <div class="search">
      <span><img src="/assets/images/common/search.svg" alt="search" /></span>
      <input
        matInput
        type="text"
        placeholder="Search"
        onfocus="placeholder = '' "
        onblur="placeholder = 'Search' "
        formControlName="searchInput"
      />
    </div>
    @if (searchFilter.get('searchInput')?.hasError('pattern')) {
    <span class="search-error"
      >Special characters &lt; &gt; % / \ are not allowed</span
    >
    }
  </div>

  @if (dayFilter.length) {
  <mat-form-field class="dropdown day-filter" floatLabel="auto">
    <mat-label class="label">Day Filter</mat-label>
    <mat-select
      [disableOptionCentering]="true"
      formControlName="dayFilter"
      panelClass="day-filter-dropdown"
    >
      @for (val of dayFilter; track val) {
      <mat-option [value]="val.value" class="option">
        <mat-radio-button>{{ val.viewValue }}</mat-radio-button>
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  } @if (filters.length) {
  <mat-form-field class="dropdown filter" floatLabel="auto">
    <mat-label class="label">FILTER</mat-label>
    <mat-select
      [disableOptionCentering]="true"
      formControlName="filters"
      panelClass="filter-dropdown"
      multiple
    >
      @for (group of filters; track group) {
      <mat-optgroup [label]="group.name">
        @for (filterValues of group.values; track filterValues) {
        <mat-option class="option" [value]="filterValues.value">
          {{ filterValues.viewValue }}</mat-option
        >
        }
      </mat-optgroup>
      }
    </mat-select>
  </mat-form-field>
  }

  <button class="merchant-btn search-btn" [disabled]="searchFilter.invalid">
    Search
  </button>
</form>
